import { Box, Collapse, Flex, Text, useDisclosure, Table, Thead, Tbody, Tr, Th, Td, Spinner, Tooltip } from '@chakra-ui/react'
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io'
import { BsClockHistory } from 'react-icons/bs'
import { useRetornarEmData } from '../../hooks/useRetornarEmData'
import { useUser } from '../../../../hooks/useUser'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

export function RetornarEm({ selectedUser }) {
  const { isOpen, onToggle } = useDisclosure()
  const { codigo_usuario } = useUser()
  const history = useNavigate()

  const { data, loading } = useRetornarEmData(selectedUser ?? codigo_usuario)

  const dataHoje = useMemo(() => {
    const today = new Date()
    const day = today.getDate()
    const month = today.getMonth() + 1

    return `${day < 10 ? `0${day}` : day}/${month < 10 ? `0${month}` : month}`
  }, [])

  const handleRedirect = (numeroNota) => {
    history(`/vendas/orcamento-pedido/${numeroNota}`)
  }

  return (
    <Box maxW="469px" position="fixed" bottom="0" left="5" right="0" bg="white" boxShadow="0 -2px 10px rgba(0,0,0,0.1)" zIndex={999}>
      <Flex
        onClick={onToggle}
        cursor="pointer"
        align="center"
        justify="space-between"
        p={3}
        borderBottom="1px solid"
        borderColor="gray.200"
        bg="white"
        color="white"
      >
        <Flex align="center" color="black" fontSize="md" gap={2}>
          <BsClockHistory color="#378BBF" size={20} />
          <Text fontWeight="semibold">Retornar em:</Text>
          <Box bg="#378BBF" color="white" px={2} py={1} borderRadius="full" fontSize="sm" fontWeight="bold">
            {dataHoje}
          </Box>
        </Flex>
        {isOpen ? <IoIosArrowDown color="#378BBF" size={20} /> : <IoIosArrowUp size={20} color="#378BBF" />}
      </Flex>

      <Collapse in={isOpen}>
        <Box maxH="300px" overflowY="auto" px={3}>
          <Box position="relative">
            {loading ? (
              <Flex justify="center" align="center" height="100%">
                <Spinner size="lg" />
              </Flex>
            ) : (
              <Table size="sm" variant="simple">
                <Thead position="sticky" top={0} zIndex={1} bg="#378BBF" boxShadow="0 2px 4px rgba(0,0,0,0.1)">
                  <Tr>
                    <Th fontWeight="normal" color="white" bgColor="#378BBF">
                      Horário
                    </Th>
                    <Th fontWeight="normal" color="white" bgColor="#378BBF">
                      Proposta
                    </Th>
                    <Th fontWeight="normal" color="white" bgColor="#378BBF">
                      Cliente
                    </Th>
                    <Th fontWeight="normal" color="white" bgColor="#378BBF">
                      Verba
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data.length === 0 && (
                    <Tr>
                      <Td colSpan={4} textAlign="center">
                        Nenhum agendamento
                      </Td>
                    </Tr>
                  )}
                  {data.map((item) => (
                    <Tooltip key={item.id} label={`Clique para ver o orçamento`} aria-label="Clique para ver o orçamento">
                      <Tr _hover={{ bg: 'gray.50', cursor: 'pointer' }} onClick={() => handleRedirect(item.numero_nota)}>
                        <Td>{item.dataRetorno.split(' ')[1]}</Td>
                        <Td>{item.proposta}</Td>
                        <Td>{item.cliente}</Td>
                        <Td>{item.verba}</Td>
                      </Tr>
                    </Tooltip>
                  ))}
                </Tbody>
              </Table>
            )}
          </Box>
        </Box>
      </Collapse>
    </Box>
  )
}
